import { Model } from 'es6/components/model'
import { entryScriptName } from 'init/entry-script-name'
import { Defaults } from 'es-decorators'

/**
 * Модель для товара в избранном
 */
@Defaults({
  idAttribute: 'item_id',
  url: `${entryScriptName}/api/v3/wish-item/`,
})
export class WishItem extends Model {}
